const _excluded = ["file", "onViewed"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { ViewerControlButtonDownload, ViewerControlsBox } from "../../controls";
import { ViewerArchiveContainer, ViewerDocumentContainer, ViewerControlsContainer } from "../../container";
import { ViewArchiveInfoError, ViewArchiveInfoLoadingIcon } from "../../status";
import { renderAsync } from 'docx-preview';
import '@isyc-react/design/main';
import "./view-word.style.scss";

// TODO implement onViewed callback

export const ViewWord = props => {
  const {
      file,
      onViewed
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const container = React.useRef(null);
  const styleContainer = React.useRef(null);
  const supported = !file.name.endsWith('.doc');
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);
  React.useEffect(() => {
    if (supported && container.current && styleContainer.current) {
      try {
        renderAsync(file, container.current, styleContainer.current, _objectSpread({
          className: 'docx',
          //class name/prefix for default and document style classes
          inWrapper: true,
          //enables rendering of wrapper around document content
          ignoreWidth: false,
          //disables rendering width of page
          ignoreHeight: false,
          //disables rendering height of page
          ignoreFonts: false,
          //disables fonts rendering
          breakPages: true,
          //enables page breaking on page breaks
          ignoreLastRenderedPageBreak: false,
          //disables page breaking on lastRenderedPageBreak elements
          experimental: false,
          //enables experimental features (tab stops calculation)
          trimXmlDeclaration: true,
          //if true, xml declaration will be removed from xml documents before parsing
          useMathMLPolyfill: false,
          //includes MathML polyfills for chrome, edge, etc.
          showChanges: false,
          //enables experimental rendering of document changes (inserions/deletions)
          debug: false
        }, rest)).then(() => setLoading(false));
      } catch (e) {
        setLoading(false);
        setError(true);
      }
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ViewerArchiveContainer, {
    className: "view-word-container"
  }, /*#__PURE__*/React.createElement(ViewerControlsContainer, {
    className: "view-word-tools"
  }, /*#__PURE__*/React.createElement(ViewerControlsBox, null, /*#__PURE__*/React.createElement(ViewerControlButtonDownload, {
    archive: {
      file
    },
    name: file.name
  }))), /*#__PURE__*/React.createElement(ViewerDocumentContainer, {
    className: "view-word-document"
  }, /*#__PURE__*/React.createElement("div", {
    ref: styleContainer
  }), loading && /*#__PURE__*/React.createElement(ViewArchiveInfoLoadingIcon, {
    name: file.name
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, "L'affichage des fichiers .doc n'est actuellement pas pris en charge")), error && /*#__PURE__*/React.createElement(ViewArchiveInfoError, null, "Erreur d'affichage du fichier"), /*#__PURE__*/React.createElement("div", {
    ref: container,
    className: "view-word-word"
  }))));
};